import type { HTMLAttributes } from 'react';
import { getStarFill, type StarsRating } from './rating';

import './stars.css';

export type { StarsRating } from './rating';
export type StarsMode = 'Light' | 'Dark';

type StarsNativeProps = Omit<HTMLAttributes<HTMLSpanElement>, 'children' | 'style'>;

export interface StarsProps extends StarsNativeProps {
  rating: StarsRating;
  mode: StarsMode;
}

const FIGMA_NODE: Record<Exclude<StarsRating, 0>, Record<StarsMode, string>> = {
  5: { Light: '26:10364', Dark: '26:10370' },
  4.5: { Light: '26:10376', Dark: '26:10382' },
  4: { Light: '26:10388', Dark: '26:10394' },
  3.5: { Light: '26:10400', Dark: '26:10406' },
  3: { Light: '26:10412', Dark: '26:10418' },
  2.5: { Light: '26:10424', Dark: '26:10430' },
  2: { Light: '26:10436', Dark: '26:10442' },
  1.5: { Light: '26:10448', Dark: '26:10454' },
  1: { Light: '26:10460', Dark: '26:10466' },
  0.5: { Light: '26:10472', Dark: '26:10478' },
};

export function Stars({
  rating,
  mode,
  className = '',
  role = 'img',
  'aria-label': ariaLabel,
  ...props
}: StarsProps) {
  const classes = ['lovo-stars', `lovo-stars--${mode.toLowerCase()}`, className]
    .filter(Boolean)
    .join(' ');

  return (
    <span
      {...props}
      aria-label={ariaLabel ?? `${rating} / 5`}
      className={classes}
      data-figma-node={rating === 0 ? undefined : FIGMA_NODE[rating][mode]}
      data-figma-variant={`Rating=${rating}, Mode=${mode}`}
      role={role}
    >
      {[0, 1, 2, 3, 4].map((index) => (
        <span
          className={`lovo-stars__star lovo-stars__star--${getStarFill(rating, index)}`}
          key={index}
          aria-hidden="true"
        />
      ))}
    </span>
  );
}
